import BlackFridayModal from 'src/components/Promotions/BlackFriday/BlackFridayModal.svelte';
import { PROMOTIONS } from 'src/constants';
import { home_data } from 'src/stores/account/user';
import { get } from 'svelte/store';

export const BlackFridayPhase1Config = (forceShow = false) => ({
	id: 'blackFridayPhase1',
	component: BlackFridayModal,
	props: {
		showModal: true,
		priority: 100, // Highest priority
		phase: 1,
	},
	rules: [
		{
			check: () => {
				const now = new Date().getTime();
				return (
					now >= PROMOTIONS.BLACK_FRIDAY_PHASE_1.START_DATE &&
					now < PROMOTIONS.BLACK_FRIDAY_PHASE_1.END_DATE &&
					(!get(home_data)?.promotions?.blackFridayPhase1 || forceShow)
				);
			},
			expected: true,
		},
	],
});
